import React from 'react';
import { Card, CardContent, Typography, CircularProgress, Box } from '@mui/material';
import { useSolution } from '../../../hooks/useSolution';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';

interface SolutionSectionProps {
  problemId: string;
  userId: string;
  show: boolean;
}

const SolutionSection: React.FC<SolutionSectionProps> = ({ problemId, userId, show }) => {
  const { solution, loading, error } = useSolution(problemId, userId);

  if (!show) return null;

  return (
    <Card variant="outlined" sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Final Solution
          {loading && <CircularProgress size={20} style={{ marginLeft: '10px' }} />}
        </Typography>

        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}

        {solution && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              bgcolor: 'grey.50',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'grey.200',
            }}
          >
            <Typography variant="subtitle2" color="primary" gutterBottom>
              Result:
            </Typography>
            <ReactMarkdown rehypePlugins={[rehypeRaw, rehypeSanitize]}>
              {solution.document}
            </ReactMarkdown>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default SolutionSection;
